import axios from 'axios';
import { configs } from '../app/app-configs';
import { PaginatedResponse } from './model/paginated-response';
import {
    BiometricDeviceUser,
    BiometricDeviceUserRequest,
    BiometricDeviceUserSearchCriteria,
} from './model/biometric.model';

export const getBiometricDeviceUserPage = async (
    search: BiometricDeviceUserSearchCriteria,
): Promise<PaginatedResponse<BiometricDeviceUser>> => {
    return await axios
        .get(
            `${configs.BASE_URL}/biometric-users/devices/${search.deviceId}?page=${search.pagination.page}&size=${search.pagination.size}&name=${encodeURIComponent(search.name)}`,
        )
        .then((res) => {
            return res.data as PaginatedResponse<BiometricDeviceUser>;
        });
};

export const createBiometricDeviceUser = async (
    request: BiometricDeviceUserRequest,
): Promise<BiometricDeviceUser> => {
    return await axios
        .post(`${configs.BASE_URL}/biometric-users`, request)
        .then((res) => {
            return res.data as BiometricDeviceUser;
        });
};

export const updateBiometricDeviceUser = async (
    request: BiometricDeviceUserRequest,
): Promise<BiometricDeviceUser> => {
    return await axios
        .put(
            `${configs.BASE_URL}/biometric-users/${request.id}`,
            request,
        )
        .then((res) => {
            return res.data as BiometricDeviceUser;
        });
};

export const deleteBiometricDeviceUser = async (id: number): Promise<number> => {
    return await axios
        .delete(`${configs.BASE_URL}/biometric-users/${id}`)
        .then((res) => {
            return res.data;
        });
};